// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Planos_tableWrapper__h658z"};